const APPROVED_STATUSES = ['APPROVED', 'ACTIVE'];

export const isStoreApproved = (status) => APPROVED_STATUSES.includes(status);

export const hasActiveSubscription = (activeSubscription, store) => {
  if (activeSubscription?.id) return true;

  const subs = store?.subscriptions || [];
  return subs.some((sub) => {
    if (!sub?.isActive) return false;
    if (!sub.expiredAt) return true;
    return new Date(sub.expiredAt) > new Date();
  });
};

/** Approved store with no active subscription — show subscription prompt */
export const shouldRequireSubscription = (store, activeSubscription) => {
  if (!store?.id) return false;
  if (!isStoreApproved(store.status)) return false;
  return !hasActiveSubscription(activeSubscription, store);
};

export const isSubscriptionRoute = (pathname = '') => {
  const path = pathname.toLowerCase();
  return (
    path.includes('/dashboard/subscriptions/create') ||
    path.includes('/dashboard/subscriptions/success') ||
    path.includes('/dashboard/subscriptions/list')
  );
};
